
import {
	UPLOAD_FILE, UPLOAD_IMAGE,
	PENDIG_IMAGES, MARK_AS_COMPLETED,
	GET_ERRORS, DELETE_IMAGES,
	PRODUCTS_WITH_IMAGES,
	FEATURED_PRODUCTS,
	GET_ALL_PRODUCTS,
	DEACTIVATE_FEATURED_PRODUCTS,
	UPDATE_FEATURED_PRODUCTS,
	PRODUCT_IMAGE_SAVED
} from "../actions/types";

const initialState = {
	deleteOk:                false,
	actionType:              '',
	error:                   '',
	totalPendingImagesPages: 0,
	pendingImages:           [],
	alreadyImages:           null,
	imageProductData:        null,
	productImageSavedData:   null,
};


export default function (state = initialState, action) {
	switch (action.type) {
		case UPLOAD_FILE:
			return {
				...state,
				actionType: action.type,
				data:       action.payload
			};
		case UPLOAD_IMAGE:
			return {
				...state,
				actionType: action.type,
				data:       action.payload
			};
		case PENDIG_IMAGES:
			return {
				...state,
				actionType:              action.type,
				pendingImages:           action.payload.pending_images,
				totalPendingImagesPages: action.payload.total

			};
		case PRODUCTS_WITH_IMAGES:
			return {
				...state,
				actionType:    action.type,
				alreadyImages: action.payload
			};
		case DELETE_IMAGES:
			return {
				...state,
				actionType: action.type,
				deleteOk:   true,
				success:    action.payload[0].message + " del no_sap: " + action.payload[0].no_sap
			};
		case FEATURED_PRODUCTS:
			return {
				...state,
				actionType:       action.type,
				featuredProducts: action.payload
			};
		case DEACTIVATE_FEATURED_PRODUCTS:
			return {
				...state,
				actionType: action.type
			};
		case UPDATE_FEATURED_PRODUCTS:
			return {
				...state,
				actionType: action.type
			};
		case GET_ALL_PRODUCTS:
			return {
				...state,
				actionType:  action.type,
				allProducts: action.payload
			};
		case GET_ERRORS:
			return {
				...state,
				actionType: action.type,
				error:      action.payload,
				message:    action.payload
			};
		case MARK_AS_COMPLETED:
			return {
				...state,
				actionType:     action.type,
				imageCompleted: action.payload
			};
		case PRODUCT_IMAGE_SAVED:
			return {
				...state,
				actionType:            action.type,
				productImageSavedData: action.payload
			};
		default:
			return state;
	}
}
